import { Matrix4, MathUtils } from "three";

import { UUID } from "../../utils/typeDefinitions";
import SceneObjectTypeEnum from "./SceneObjectTypeEnum";
import SceneObjectTypeData from "./SceneObjectTypeData";
import EditHandleTypeEnum from "../../enums/EditHandleTypeEnum";
import { DragMeasurement } from "../../utils/dragMeasurement";

export default abstract class SceneObjectData
{
    uuid: UUID;
    type: SceneObjectTypeEnum;  
    parentId?: UUID; // UUID of the parent object, if any
    ownedBy?: string;
    modifiedAt?: Date;
    sceneObjectTypeData: SceneObjectTypeData | null = null;

    constructor(type: SceneObjectTypeEnum, uuid?: UUID, parentId?: UUID, ownedBy?: string, modifiedAt?: Date) {
        this.type = type;
        this.uuid = uuid ?? MathUtils.generateUUID();
        this.parentId = parentId;
        this.ownedBy = ownedBy;
        this.modifiedAt = modifiedAt;
    }

    abstract clone(): this;
    abstract applyMatrix4(matrix: Matrix4): void;

    protected copyBaseData(clone: this): void {
        clone.ownedBy = this.ownedBy;
        clone.modifiedAt = this.modifiedAt;
        clone.sceneObjectTypeData = this.sceneObjectTypeData;
    }

    // What the cursor readout should say while the given quantity is being dragged — either by its
    // edit handle or, for shapes that are drawn by dragging, while being created. Returning
    // undefined leaves the generic point-to-point distance readout in place. Called on every
    // pointer move, so keep overrides pure and cheap.
    getDragMeasurement(_handleType: EditHandleTypeEnum): DragMeasurement | undefined {
        return undefined;
    }

    toJson(): any {
        return {
            uuid: this.uuid,
            type: this.type,
            parentId: this.parentId ?? null,
        };
    }
}